import { defineMessage } from 'services/localization';

export const messages = {
    created: defineMessage('created_createddate'),
    areYouSure: defineMessage('are_you_sure_you_want_to_delete_this_passkey'),
    yes: defineMessage('yes_delete_it'),
    placeholder: defineMessage('enter_passkey_label'),
    buttonSave: defineMessage('save'),
    buttonEdit: defineMessage('edit'),
    buttonDelete: defineMessage('delete'),
};
